import type { AdminPublic } from "shared";
import { api } from "./client";

export async function loginWithPassword(
	email: string,
	password: string,
): Promise<{ admin: AdminPublic }> {
	return api.post("/auth/login", { email, password });
}

export async function loginWithToken(
	token: string,
): Promise<{ admin: AdminPublic }> {
	return api.post("/auth/login", { token });
}

export async function logout(): Promise<void> {
	await api.post("/auth/logout");
}

export async function fetchMe(): Promise<{ admin: AdminPublic | null }> {
	return api.get("/me");
}

export async function requestReset(email: string): Promise<void> {
	await api.post("/auth/reset-request", { email });
}

export async function resetPassword(
	code: string,
	newPassword: string,
): Promise<void> {
	await api.post("/auth/reset", { code, newPassword });
}

export async function changePassword(
	currentPassword: string,
	newPassword: string,
): Promise<void> {
	await api.post("/auth/change-password", { currentPassword, newPassword });
}

export async function rotateToken(): Promise<{
	token: string;
	loginUrl: string;
}> {
	return api.post("/auth/rotate-token");
}
